import { render, staticRenderFns } from "./PurchaseAndSaleCategoryCompare.vue?vue&type=template&id=7c817c50&scoped=true&"
import script from "./PurchaseAndSaleCategoryCompare.vue?vue&type=script&lang=js&"
export * from "./PurchaseAndSaleCategoryCompare.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAndSaleCategoryCompare.vue?vue&type=style&index=0&id=7c817c50&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c817c50",
  null
  
)

export default component.exports